import { render, staticRenderFns } from "./OrganizationNonProfitReviewStatus.vue?vue&type=template&id=61e542d8"
import script from "./OrganizationNonProfitReviewStatus.vue?vue&type=script&lang=ts"
export * from "./OrganizationNonProfitReviewStatus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports